import { Grid } from '@material-ui/core'
import { useFormikContext } from 'formik'
import { EmergencyRoomEditFormikValues } from 'presentation/hospital/layouts/EmergencyRoom/EmergencyRoomDetails/types'
import Button from 'presentation/shared/components/Button'
import Heading from 'presentation/shared/components/Heading'
import { Asterisk } from 'presentation/shared/components/SelectField/styles'
import SupportText from 'presentation/shared/components/SupportText'
import React from 'react'

export function DefaultDoctorInfo() {
  const { values, setValues } =
    useFormikContext<EmergencyRoomEditFormikValues>()

  const handleEdit = () => {
    setValues({
      ...values,
      useDefaultDoctor: undefined,
      doctor: undefined
    })
  }

  const renderDoctorInfo = () => {
    return (
      <Grid container item direction="column" xs={12} spacing={2}>
        <SupportText color="primary">Médico selecionado:</SupportText>
        <Heading size="xlarge" color="primary">
          {values.doctor?.name}
        </Heading>
        <Grid
          container
          item
          direction="row"
          xs={10}
          spacing={2}
          style={{ gap: '5px' }}
        >
          <SupportText color="primary">CRM: </SupportText>
          <SupportText color="gray">
            {values.doctor?.crm}
            {values.doctor?.crmUf ? '-' + values.doctor?.crmUf : null}
          </SupportText>
        </Grid>
      </Grid>
    )
  }

  return (
    <>
      <Grid
        container
        item
        direction="row"
        xs={12}
        spacing={2}
        alignItems="center"
      >
        <Grid
          container
          item
          direction="row"
          xs={10}
          spacing={2}
          style={{ gap: '5px' }}
        >
          <SupportText color="primary">
            <strong>
              Deseja seguir com o médico padrão? <Asterisk>*</Asterisk>
            </strong>
          </SupportText>
          <SupportText color="gray">
            {values.useDefaultDoctor ? 'Sim' : 'Não'}
          </SupportText>
        </Grid>
        <Grid container item direction="row" xs={2} spacing={2}>
          <Button
            fullWidth
            type="button"
            variant="outlined"
            onClick={handleEdit}
          >
            Editar
          </Button>
        </Grid>
        {values.doctor && renderDoctorInfo()}
      </Grid>
    </>
  )
}
